// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6d0aed2c","488":"67436cf9","977":"6afd02c6"}[chunkId] + ".chunk.js";
};